<template>
	<div>
		<v-card tile elevation="0" class="arp-aba-informacoes">
			<v-card-text class="pa-0">
				<v-form v-model="isFormValid" ref="frmInfoAta" lazy-validation>
					<v-expansion-panels :value="paineisAbertos" @change="setPaineisAbertos" multiple flat>
						<v-expansion-panel class="mb-2" active-class="aberto" flat>
							<v-expansion-panel-header class="collapse-selecionados-header" ripple>
								<h4>Dados Gerais</h4>
							</v-expansion-panel-header>
							<v-expansion-panel-content class="collapse-selecionados-conteudo">
								<v-row class="my-3 mx-1">
									<v-col cols="12">
										<label-personalizado nome-campo="Descrição"></label-personalizado>
										<v-textarea
											underlined
											v-model="infoAta.descricao"
											auto-grow
											rows="1"
											disabled
										></v-textarea>
									</v-col>
									<v-col cols="12" sm="1">
										<label-personalizado nome-campo="Permite Adesão"></label-personalizado>
										<v-checkbox
											label="Sim"
											:disabled="
												infoAta.isAdesao ||
												!temPermissaoEdicao ||
												infoAta.isBloqueado ||
												isAtaCancelada
											"
											v-model="infoAta.isPermiteAdesao"
										></v-checkbox>
									</v-col>
									<v-col cols="12" sm="3" v-if="isIntegracaoTceAtivo">
										<label-personalizado
											nome-campo="Número de Identificação"
											obrigatorio-por-padrao
										></label-personalizado>
										<v-text-field
											v-model="infoAta.numeroIdentificacaoProcesso"
											:rules="[
												() => {
													if (!infoAta.numeroIdentificacaoProcesso) return true

													return (
														infoAta.numeroIdentificacaoProcesso.trim().length <= 24 ||
														'O número não pode ser maior que 24 caracteres.'
													)
												},
											]"
											:disabled="
												infoAta.isAdesao ||
												!temPermissaoEdicao ||
												infoAta.isBloqueado ||
												infoAta.isEnviadoDetalhamento ||
												isAtaCancelada
											"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="2">
										<label-personalizado
											nome-campo="DOE"
											:obrigatorio-por-padrao="doeObrigatorio"
										></label-personalizado>
										<v-text-field
											v-model="infoAta.doe"
											:disabled="
												infoAta.isAdesao ||
												!temPermissaoEdicao ||
												infoAta.isBloqueado ||
												(infoAta.situacao === 'EFETIVADO' && doeObrigatorio) ||
												isAtaCancelada
											"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="4" v-if="utilizaContratacaoExterna">
										<label-personalizado nome-campo="ID Contratação PNCP"></label-personalizado>
										<v-text-field
											v-model="infoAta.idContratacaoPncp"
											:disabled="
												infoAta.isAdesao ||
												!temPermissaoEdicao ||
												infoAta.isBloqueado ||
												infoAta.isEnviadaPncp ||
												isAtaCancelada
											"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="2">
										<input-text-de-data
											:is-obrigatorio="true"
											nome-do-campo="Início Validade"
											:validation-rules="inicioValidadeRules"
											:value.sync="infoAta.inicioValidade"
											:error="errorVigencia"
											:error-messages="mensagemVigencia"
											:disabled="!temPermissaoEdicao || infoAta.isBloqueado || isAtaCancelada"
										></input-text-de-data>
									</v-col>
									<v-col cols="12" sm="2">
										<input-text-de-data
											:is-obrigatorio="true"
											nome-do-campo="Fim Validade"
											:value.sync="infoAta.fimValidade"
											:validation-rules="fimValidadeRules"
											:error="errorVigencia"
											:error-messages="mensagemVigencia"
											:disabled="!temPermissaoEdicao || infoAta.isBloqueado || isAtaCancelada"
										></input-text-de-data>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<v-expansion-panel class="my-2" active-class="aberto" flat>
							<v-expansion-panel-header class="collapse-selecionados-header" ripple>
								<h4>Dados da Assinatura</h4>
							</v-expansion-panel-header>
							<v-expansion-panel-content class="collapse-selecionados-conteudo">
								<v-row class="my-3 mx-1">
									<v-col cols="12" sm="4">
										<label-personalizado
											nome-campo="Contratado"
											:obrigatorio-por-padrao="isContratadoObrigatorio"
										></label-personalizado>
										<v-autocomplete
											v-model="idContratado"
											:items="listaContratados"
											placeholder="Selecione"
											item-text="nome"
											item-value="id"
											:rules="contratadoRules"
											clearable
											:disabled="
												infoAta.isAdesao ||
												!temPermissaoEdicao ||
												infoAta.isBloqueado ||
												isAtaCancelada
											"
										>
											<template #item="{ item, on, attrs }">
												<v-list-item v-bind="attrs" v-on="on">
													<v-list-item-content>
														<v-list-item-title class="text-body-2">
															{{ item.nome }}
														</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
											</template>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" sm="3">
										<input-text-de-data
											is-obrigatorio
											nome-do-campo="Data de Assinatura da ARP"
											:value.sync="infoAta.dataAssinatura"
											:validation-rules="dataAssinaturaRules"
											:disabled="
												infoAta.isAdesao ||
												!temPermissaoEdicao ||
												infoAta.isBloqueado ||
												isAtaCancelada
											"
										></input-text-de-data>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						<listagem-historico-vigencia
							v-if="isAtaProrrogada"
							:is-ata-cancelada="isAtaCancelada"
							:busca="getFiltroHistoricoProrrogacoes(idAta)"
						></listagem-historico-vigencia>
					</v-expansion-panels>
				</v-form>
			</v-card-text>
			<v-divider class="mt-2"></v-divider>
			<v-card-actions>
				<v-container fluid class="py-4 white container-botao">
					<botao-cancelar-confirmar
						:acao-cancelar="voltarParaListagem"
						:acao-confirmar="salvarAta"
						nome-botao-confirmar="Salvar"
						:is-confirmar-visivel="temPermissaoEdicao && !isAtaCancelada"
						:is-confirmar-desabilitado="!isFormValid || infoAta.isBloqueado"
						:permissao-confirmar="permissoes.ataEditar"
					></botao-cancelar-confirmar>
				</v-container>
			</v-card-actions>
		</v-card>
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { actionTypes, getterTypes, mutationTypes, routesNames } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { DataUtils } from '@/core/utils'
import validacaoAta from '@/views/mixins/validacaoAta'
import ListagemHistoricoVigencia from '@/views/pages/ata/acessar/gestao-da-ata/informacoes/listagem-historico-vigencia/ListagemHistoricoVigencia.vue'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'acessar-ata-informacoes-view',
	components: { ListagemHistoricoVigencia },
	mixins: [validacaoFormulario, validacaoAta],
	inject: ['idAta'],
	beforeRouteLeave(to, from, next) {
		this.$store.commit(mutationTypes.ATA.SET_PAINEIS_INFORMACOES_ABERTOS, [0, 1])
		next()
	},
	data() {
		return {
			isFormValid: true,
			inicioValidadeRules: [(v) => this.regraObrigatoriedade(v, 'Inicio da validade é obrigatória.')],
			fimValidadeRules: [(v) => this.regraObrigatoriedade(v, 'Fim da validade é obrigatória.')],
			dataAssinaturaRules: [(v) => this.regraObrigatoriedade(v, 'Data de Assinatura é obrigatória.')],
			contratadoRules: [
				(v) => {
					if (this.isContratadoObrigatorio) return this.regraObrigatoriedade(v, 'Contratado é obrigatório.')
					return true
				},
			],
			errorVigencia: false,
			mensagemVigencia: ['O prazo da validade da ata não pode ser maior que 1 (um) ano.'],
			doeObrigatorio: this.$store.state.parametrosSistema.doeObrigatorio,
			idContratado: null,
		}
	},
	computed: {
		...mapState({
			infoAta: (state) => state.ata.informacoesAta,
			paineisAbertos: (state) => state.ata.paineisInformacoesAbertos,
			listaContratados: (state) => state.ata.listaContratados,
			utilizaContratacaoExterna: (state) => state.parametrosSistema.utilizaContratacaoExterna,
			isIntegracaoTceAtivo: (state) => state.parametrosSistema.isIntegracaoTceAtivo,
			isContratadoObrigatorio: (state) => state.parametrosSistema.contratadoObrigatorio,
			isAtaProrrogada: (state) => state.ata.informacoesAta.isAtaProrrogada,
		}),
		...mapGetters({
			cabecalho: getterTypes.ATA.GET_ATA_PARA_CABECALHO,
		}),
		isAtaCancelada() {
			return this.estaCancelada(this.infoAta.situacao)
		},
	},
	watch: {
		infoAta: {
			handler(novoValor) {
				const diferencaValida = novoValor.utilizaVigenciaDias
					? DataUtils.isDiferencaEntreDatasMenorQueQtdAnos(novoValor.inicioValidade, novoValor.fimValidade, 1)
					: DataUtils.isDiferencaEntreDatasMenorIgualA(
							novoValor.inicioValidade,
							novoValor.fimValidade,
							1,
							'year',
					  )

				this.errorVigencia = !diferencaValida
				this.isFormValid = diferencaValida
			},
			deep: true,
		},
	},

	async created() {
		await this.$store.dispatch(actionTypes.ATA.BUSCAR_CONTRATADOS, this.idAta)
		const { contratado } = await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.idAta)
		this.selecionarContratado(contratado)
	},

	methods: {
		voltarParaListagem() {
			this.$router.push({ name: routesNames.ATA.ATA_VIEW })
		},
		async salvarAta() {
			if (!this.$refs.frmInfoAta.validate()) return

			if (!this.idContratado && this.listaContratados.length === 1) {
				this.idContratado = this.listaContratados.at(0)?.id || null
			}

			await this.$store
				.dispatch(actionTypes.ATA.ATUALIZAR_ATA_COM_PROCESSO, this.idContratado)
				.then(() => this.atualizarInformacoesAta())
				.catch(() => this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.idAta))
		},
		async atualizarInformacoesAta() {
			const { contratado } = await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.idAta)
			this.selecionarContratado(contratado)
			this.mostrarNotificacaoSucessoDefault()
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, this.cabecalho)
		},
		selecionarContratado(contratado) {
			if (!contratado && this.listaContratados.length === 1) {
				this.idContratado = this.listaContratados.at(0)?.id || null
				return
			}
			if (!contratado) return

			if (!this.listaContratados.some((c) => c.id === contratado.id)) this.listaContratados.push(contratado)
			this.idContratado = contratado.id
		},
		getFiltroHistoricoProrrogacoes() {
			return {
				filtro: {
					idAta: this.idAta,
				},
				paginacao: paginacaoListagem(['id']),
			}
		},
		setPaineisAbertos(valor) {
			this.$store.commit(mutationTypes.ATA.SET_PAINEIS_INFORMACOES_ABERTOS, valor)
		},
	},
}
</script>
<style lang="stylus">
estilo-padrao()
	border .1rem solid var(--v-grey-lighten1)
	border-radius .3rem

.arp-aba-informacoes
	margin-top 1.125rem

	.col, .col-12
		padding .1rem .5rem !important

	.v-expansion-panel--active.aberto > .v-expansion-panel-header
		min-height auto

	.aberto .collapse-selecionados-header
		border-bottom-left-radius 0
		border-bottom-right-radius 0

	.aberto .collapse-selecionados-conteudo
		border-top-color transparent
		border-top-left-radius 0
		border-top-right-radius 0
		color var(--v-grey-darken1)

	.collapse-selecionados-header
		background-color var(--v-grey-lighten4)
		color var(--v-grey-darken1)
		estilo-padrao()

	.collapse-selecionados-conteudo
		estilo-padrao()
		padding-top: .5%;


.arp-label-personalizado
	font-size .75rem !important

.container-botao
	border-top 1px solid #CDCDCD
	margin-left -0.4rem !important
</style>
